import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const getStatusSATDescargaMasivaRequest = (data) => {
    const config = {
        path: `Status/${data.service}`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}